export default __webpack_public_path__ + "/dist/images/user_profile-img.9f4ec6437bc021c2986626742c070e00.png";